<template>
  <div>
    <b-taglist class="taglist" attached v-if="acuityScoreObject">
      <b-tag type="is-primary" v-tooltip="{ content: time, disabled: isInline }">{{ parseFloat(acuityScoreObject.acuity_score).toFixed(1) }}</b-tag>
      <b-tag type="is-primary is-light" v-if="isInline">{{ time }}</b-tag>
    </b-taglist>
    <span v-else>N/A</span>
  </div>
</template>

<script>
export default {
  name: "AcuityScore",
  props: {
    acuityScoreObject: {
      type: Object,
      required: false,
      default: null
    },
    isInline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    time() {
      return this.acuityScoreObject?.hour_bin ? this.$helpers.formatDate(this.acuityScoreObject.hour_bin, 'LT') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.taglist) {
  &:last-child {
    margin-bottom: 0;
  }
  .tag {
    margin-bottom: 0 !important;
  }
}
</style>